import {Col, DropdownItem, FormGroup} from "reactstrap";
import React, {useEffect} from "react";
import GET_USER from "../../../../graphql/queries/user";
import Select from "react-select";
import {useQuery} from "@apollo/client";
import {getSessionId} from "../../../../services/session";

interface LocationProps {
    location: any
    setLocation: (location) => void,
    locations: any[]
    placeHolder: string
    label: string
    pickerId: string
    findChosenLocation: (camperFilter) => (location) => any
    loadFromLastSelectedFilter?: boolean
}

const Location = ({location, setLocation, locations, placeHolder, label, pickerId, findChosenLocation, loadFromLastSelectedFilter}: LocationProps) => {
    const sessionId = getSessionId();
    const {loading, error, data, client} = useQuery(GET_USER, {
        variables: {
            uuid: sessionId,
        },
    });

    useEffect(() => {
        if (!loadFromLastSelectedFilter) {
            return;
        }

        if (locations.length > 0 && data && data.user && data.user.lastSelectedCamperFilter) {
            const camperFilter = data.user.lastSelectedCamperFilter

            setLocation(locations.find(findChosenLocation(camperFilter)));
        }
    }, [data, locations])

    return (
        <>
            <DropdownItem header toggle={false}>
                {label}
            </DropdownItem>
            <DropdownItem toggle={false}>
                <Select
                    value={location}
                    instanceId={pickerId}
                    options={locations}
                    placeholder={placeHolder}
                    className="selectpicker"
                    classNamePrefix="selectpicker"
                    onChange={(location) => {
                        setLocation(location)
                    }}
                />
            </DropdownItem>
        </>
    )
}

export default Location;
